import React, { useState, useEffect } from 'react';
import { discussionService } from '../services/api';
import { Discussion } from '../types';
import DiscussionCard from './DiscussionCard';

const DiscussionList: React.FC<{ status?: string }> = ({ status = 'published' }) => {
  const [discussions, setDiscussions] = useState<Discussion[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    setLoading(true);
    discussionService
      .getAll(status)
      .then((res) => setDiscussions(res.data))
      .catch(() => setError('Failed to load discussions'))
      .finally(() => setLoading(false));
  }, [status]);

  if (loading) return <div className="text-center p-4">Loading discussions...</div>;
  if (error) return <div className="text-center p-4 text-red-600">{error}</div>;
  if (discussions.length === 0) return <div className="text-center p-4">No discussions found</div>;

  return (
    <div className="discussion-stack">
      {discussions.map((discussion) => (
        <DiscussionCard key={discussion.id} discussion={discussion} />
      ))}
    </div>
  );
};

export default DiscussionList;
